import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {Product} from '../../entities/product';
import {StyleService, StyleType} from '../../services/style.service';

@Component({
    selector: 'app-payment-failed',
    templateUrl: './payment-failed.component.html',
    styleUrls: ['./payment-failed.component.scss'],
})
export class PaymentFailedComponent implements OnInit, OnDestroy {
    public readonly StyleType = StyleType;

    @Input()
    product: Product;
    paymentType: string;
    selectedAdditions: Product[] = [];

    value: number = 0;
    timer = 30;
    interval;

    orderText = "";

    constructor(
        private modalCtrl: ModalController,
        public styleService: StyleService) { }

    ngOnInit() {
        this.interval = setInterval(() => {
            this.timer--;
            if (this.timer <= 0) {
                this.dismiss('timer')
            }
        }, 1000)

        if(this.product) {
            this.orderText = `${this.product.name || '-'}`;
            if (this.paymentType != 'Kupon')
                this.orderText += ` - ${this.product.price || '-'} kr.`
            if (this.selectedAdditions && this.selectedAdditions.length > 0) {
                this.selectedAdditions.forEach(add => {
                    this.orderText += `, ${add.name || '-'}`;
                    if (this.paymentType != 'Kupon')
                        this.orderText += ` - ${add.price || '-'} kr.`
                })
            }
        }
    }

    ngOnDestroy() {
        clearInterval(this.interval)
    }

    dismiss(status) {
        clearInterval(this.interval)
        this.modalCtrl.dismiss({
            'status': status
        })
    }

    isContactless() {
        return this.paymentType === 'Kontaktløs';
    }
}
